import { EMPTY_OBJECT } from '../../../../../constants/common'
import { POST_LIST_API_PAGE_SIZE } from '../../../../Post'
import {
  ENTITY_TAB_POSTS_FILTER_SUB_MENU,
  ENTITY_TAB_POSTS_SCALAR_SCOPE_FILTER_KEYS,
  ENTITY_TAB_POSTS_SEARCH_FILTER_KEY,
} from '../../EntityTabPosts.constants'

export function getEntityTabPostsBaseFilters({
  filterValues,
  scopeFilterKey,
  scopeId,
  searchQuery,
}) {
  return {
    ...filterValues,
    ...(searchQuery
      ? { [ENTITY_TAB_POSTS_SEARCH_FILTER_KEY]: searchQuery }
      : EMPTY_OBJECT),
    [scopeFilterKey]: ENTITY_TAB_POSTS_SCALAR_SCOPE_FILTER_KEYS.includes(
      scopeFilterKey
    )
      ? scopeId
      : [scopeId],
    sub_menu: ENTITY_TAB_POSTS_FILTER_SUB_MENU,
  }
}

export function getEntityTabPostsApiParams({
  filterValues,
  ordering,
  scopeFilterKey,
  scopeId,
  searchQuery,
}) {
  return {
    filters: getEntityTabPostsBaseFilters({
      filterValues,
      scopeFilterKey,
      scopeId,
      searchQuery,
    }),
    ordering,
    size: POST_LIST_API_PAGE_SIZE,
  }
}
